import React from 'react';
import { NotificationItem } from './NotificationItem';

export const NotificationGroup = ({
    groupName,
    notifications,
    userCache,
    selectionMode,
    selectedIds,
    processingIds,
    openMenuId,
    currentUser,
    navigate,
    toggleSelected,
    handleNotificationClick,
    handleMarkRead,
    handleDeleteNotification,
    handleFollowRequestAccept,
    handleFollowRequestReject,
    handleAccept,
    handleDecline,
    toggleMenu
}) => {
    if (!notifications || notifications.length === 0) return null;

    return (
        <div className="notification-date-group">
            <div className="notification-group-header">
                <span className="notification-group-label">{groupName}</span>
                <span className="notification-group-count">{notifications.length}</span>
            </div>
            {notifications.map((notification) => (
                <NotificationItem
                    key={notification.id}
                    notification={notification}
                    userCache={userCache}
                    selectionMode={selectionMode}
                    selectedIds={selectedIds}
                    processingIds={processingIds}
                    openMenuId={openMenuId}
                    currentUser={currentUser}
                    navigate={navigate}
                    toggleSelected={toggleSelected}
                    handleNotificationClick={handleNotificationClick}
                    handleMarkRead={handleMarkRead}
                    handleDeleteNotification={handleDeleteNotification}
                    handleFollowRequestAccept={handleFollowRequestAccept}
                    handleFollowRequestReject={handleFollowRequestReject}
                    handleAccept={handleAccept}
                    handleDecline={handleDecline}
                    toggleMenu={toggleMenu}
                />
            ))}
        </div>
    );
};
